// extracted by mini-css-extract-plugin
module.exports = {"payment-info":"style_payment-info__C63IW","file-upload":"style_file-upload__2ia5X"};